import { When } from "react-if";

import { SmallSpinner } from "../../../common/Atoms/SmallSpinner";
import { classNames } from "../../../common/lib/classNames";
import { Paragraph } from "../../../common/Atoms/Typography/Paragraph";

interface LoadingOverlayProps {
  className?: string;
  loading: boolean;
  message?: string;
  children: React.ReactNode;
  contrast?: `dark` | `light`;
  messageOnly?: boolean;
}

export function LoadingOverlay({ className, loading, children, message, contrast = `dark`, messageOnly }: LoadingOverlayProps) {
  return (
    <div className={
      classNames(
        `relative`,
        className,
        (loading && !messageOnly) && `cursor-wait`,
        loading ? (contrast === `light` && `opacity-50`) : ``,
      )
    }>
      <When condition={ loading }>
        <div className={
          classNames(
            `absolute top-0 left-0 w-full h-full flex items-center justify-center z-50`,
            contrast === `dark` ? `bg-white/50` : `bg-white`,
          )
        } >
          <div className={ `flex flex-col items-center` }>
            <When condition={ !messageOnly }>
              <SmallSpinner
                size={ `lg` }
                colored
              />
            </When>
            <When condition={ !!message && !messageOnly }>
              <Paragraph
                className={ `mt-2` }
                variant={ `secondary` }
                size={ `md` }
              >
                { message }
              </Paragraph>
            </When>

            <When condition={ !!message && messageOnly }>
              <div className={ `bg-white rounded-lg shadow-md p-4` }>
                <Paragraph
                  className={ `mt-2` }
                  variant={ `secondary` }
                  size={ `md` }
                >
                  { message }
                </Paragraph>
              </div>
            </When>
          </div>
        </div>
      </When>
      { children }
    </div>
  );
}
